import Swiper from '../vendor/swiper.min.js';

function getOffset(el) {
    let _x = 0;
    let _y = 0;
    while( el && !isNaN( el.offsetLeft ) && !isNaN( el.offsetTop ) ) {
        _x += el.offsetLeft - el.scrollLeft;
        _y += el.offsetTop - el.scrollTop;
        el = el.offsetParent;
    }
    return { top: _y, left: _x };
}

export default class HomePage {
    constructor() {

    }

    init() {

        this.quizSlider();
        this.quizTabs();
        this.quiz();

        const self = this;
        const xmlns = "http://www.w3.org/2000/svg";
        const svgEl = document.getElementById('js-location');

        const circle = this.createEl(xmlns, 'circle', 'dot', '#01fbff', 'none', '44');
        const circle2 = this.createEl(xmlns, 'circle', 'dot', '#01fbff', 'none', '28');
        const circle3 = this.createEl(xmlns, 'circle', 'dot', 'none', '#01fbff', '20');
        const circleZagorje = this.createEl(xmlns, 'circle', 'is-zagorje', 'none', '#01fbff', '14');
        const circleDalmacija = this.createEl(xmlns, 'circle', 'is-dalmacija', 'none', '#01fbff', '14');
        const circleVelebit = this.createEl(xmlns, 'circle', 'is-velebit', 'none', '#01fbff', '14');
        const circleIstra = this.createEl(xmlns, 'circle', 'is-istra', 'none', '#01fbff', '14');
        const circleZagreb = this.createEl(xmlns, 'circle', 'is-zagreb', 'none', '#01fbff', '14');

        svgEl.appendChild(circle);
        svgEl.appendChild(circle2);
        svgEl.appendChild(circle3);
        svgEl.appendChild(circleZagorje);
        svgEl.appendChild(circleDalmacija);
        svgEl.appendChild(circleVelebit);
        svgEl.appendChild(circleIstra);
        svgEl.appendChild(circleZagreb);

        circleZagorje.setAttribute("transform", "translate(230,565)");

        this.setElPosition(circleZagorje, 227, 565);
        this.setElPosition(document.querySelectorAll('.is-zagorje-distance')[0], 270, 580);
        this.setElPosition(circleDalmacija, 352, 1967);
        this.setElPosition(document.querySelectorAll('.is-dalmacija-distance')[0], 400, 1980);
        this.setElPosition(circleVelebit, 363, 3205);
        this.setElPosition(document.querySelectorAll('.is-velebit-distance')[0], 400, 3220);
        this.setElPosition(circleZagreb, 365, 4560);
        this.setElPosition(document.querySelectorAll('.is-zagreb-distance')[0], 400, 4560);
        this.setElPosition(circleIstra, 305, 5867);
        this.setElPosition(document.querySelectorAll('.is-istra-distance')[0], 350, 5867);

        // Update dot position when we get a scroll event.
        window.addEventListener("scroll", self.positionTheDot);
    }

    quiz() {

        $('.js-q-step-btn').on('click', function(ev) {
            // ev.preventDefault();

            if($(this).attr('data-target').length > 0) {
                $('.q-step').removeClass('is-active');
                $($(this).attr('data-target')).addClass('is-active');
                TweenMax.to($('html, body'), 1, {
                    scrollTop: $($(this).attr('data-target')).offset().top - $('.c-navigation').outerHeight(),
                    ease: Power2.easeOut
                });
            }
        });

    }

    quizTabs() {

        $('.js-quiz-tab-nav').on('click', function(ev) {
            ev.preventDefault();

            if($(this).attr('data-status') === 'off') {
                $('.c-quiz__item').removeClass('is-active');
                $('.js-quiz-tab-nav').attr('data-status', 'off');
                $('.c-quiz__tab').removeClass('is-active');
                $(this).parent().addClass('is-active');
                $(this).attr('data-status', 'on');
                $($(this).attr('data-target')).addClass('is-active');

            }

        });
    }

    quizSlider() {

        $('.js-swiper-quiz').each(function() {

            let mySwiper = new Swiper (this, {
                // Optional parameters
                autoHeight: true,
                slidesPerView: 1,
                direction: 'horizontal',
                loop: true,
                speed: 500,
                autoplay: false,
                // autoplay: {
                //     delay: 5000,
                // },
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                observer: true,
                observeParents: true,
            });
            let self = this;
            mySwiper.on('slideChange', function() {
                $(self).parents('.c-quiz-tab').find('.js-slider-nav').removeClass('is-active');
                $(self).parents('.c-quiz-tab').find('.js-slider-nav').parent().removeClass('is-active');
                $(self).parents('.c-quiz-tab').find('.js-slider-nav').eq(this.realIndex).addClass('is-active');
                $(self).parents('.c-quiz-tab').find('.js-slider-nav').eq(this.realIndex).parent().addClass('is-active');
            });
            $(this).parents('.c-quiz-tab').find('.js-slider-nav').on('click', function(ev) {
                ev.preventDefault();
                mySwiper.slideTo($(this).data('index') + 1);
            });
        });
    }

    setElPosition(el, x, y) {
        return el.setAttribute("transform", "translate(" + x + ","+ y +")");
    }

    /**
     *
     * @param xmlns
     * @param type
     * @param className
     * @param strokeColor
     * @param fillColor
     * @param radius
     * @returns {Element}
     */
    createEl (xmlns, type, className, strokeColor, fillColor, radius) {

        let el = document.createElementNS(xmlns, type);
        el.setAttribute('class', className);
        el.setAttribute('stroke', strokeColor);
        el.setAttribute('fill', fillColor);
        el.setAttribute('r', radius);
        el.setAttribute('cx', '0');
        el.setAttribute('cy', '0');

        return el;

    }

    positionTheDot() {

        if((document.documentElement.scrollTop + document.body.scrollTop + document.documentElement.clientHeight) >= getOffset(document.querySelectorAll(".c-locations")[0]).top) {

            // What percentage down the page are we?
            // let scrollPercentage = ((document.documentElement.scrollTop + document.body.scrollTop)) / (document.documentElement.scrollHeight - document.documentElement.clientHeight);
            //
            let scrollPercentage = ((document.documentElement.scrollTop + document.body.scrollTop + document.documentElement.clientHeight) - getOffset(document.querySelectorAll(".c-locations")[0]).top) / (document.querySelectorAll(".c-locations")[0].scrollHeight - document.documentElement.clientHeight);

            // console.log(scrollPercentage.toFixed(2));
            // (scrollPercentage.toFixed(2) >= 0.10) ? setActive(0.10):removeActive(0.10);

            if(scrollPercentage.toFixed(2) >= 0.10) {
                $('.is-zagorje-distance').addClass('is-active');
            } else {
                $('.is-zagorje-distance').removeClass('is-active');
            }

            if(scrollPercentage.toFixed(2) >= 0.33) {
                $('.is-dalmacija-distance').addClass('is-active');
            } else {
                $('.is-dalmacija-distance').removeClass('is-active');
            }

            if(scrollPercentage.toFixed(2) >= 0.48) {
                $('.is-velebit-distance').addClass('is-active');
            } else {
                $('.is-velebit-distance').removeClass('is-active');
            }

            if(scrollPercentage.toFixed(2) >= 0.66) {
                $('.is-zagreb-distance').addClass('is-active');
            } else {
                $('.is-zagreb-distance').removeClass('is-active');
            }
            if(scrollPercentage.toFixed(2) >= 0.81) {
                $('.is-istra-distance').addClass('is-active');
            } else {
                $('.is-istra-distance').removeClass('is-active');
            }

            // Get path length
            const path = document.getElementById("theMotionPath");
            let pathLen = path.getTotalLength();

            // console.log(pathLen);

            // Get the position of a point at <scrollPercentage> along the path.
            let pt = path.getPointAtLength((scrollPercentage) * pathLen);

            // Position the red dot at this point
            const dot = document.querySelectorAll(".dot");
            dot[0].setAttribute("transform", "translate("+ pt.x + "," + pt.y + ")");
            dot[1].setAttribute("transform", "translate("+ pt.x + "," + pt.y + ")");
            dot[2].setAttribute("transform", "translate("+ pt.x + "," + pt.y + ")");

        }

    }

    draad() {

        /*const newDraad = new Draad("js-element", {
            parentClass: "container",
            lineWidth: 10,
            dasharray: "40 35",
            responsive: true,
            color: "#111",
            smoothing: 0.25,
            cap: "round"
        });*/

        // positionTheDot();

    }
}


// WEBPACK FOOTER //
// ./static/js/pages/HomePage.js